import React, { useRef } from "react";
import { Form, Input, InputNumber, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";

const { TextArea } = Input;

const InterviewResult = ({ open, handleCancel, title, handleFetch, prodd,onClose }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saving } = useSelector((state) => state.save);

  const handleSubmit = async (data) => {
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/applications/create",
        japProgressStatus: "INTERVIEW_RESULT",
        japId: prodd?.japId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetch();
       await onClose();
      await handleCancel();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={title}
        open={open}
        onOk={handleSubmit}
        onCancel={handleCancel}
        width={580}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={handleSubmit}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="text-[#0E0E0E] text-[1rem] font-[400] font-dmSans mb-2">
            Give results and comment for this candidate
          </div>
          <Form.Item
            name="japInterviewScore"
            label="Marks (%)"
            rules={[
              {
                required: true,
                message: "Please add marks(%)",
              },
            ]}
          >
            <InputNumber
              min={0}
              max={100}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            name="japInterviewRemarks"
            label="Comments"
            rules={[
              {
                required: true,
                message: "Enter comments",
              },
            ]}
          >
            <TextArea rows={6} className="input" />
          </Form.Item>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[150px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn-2"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[150px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default InterviewResult;
